import { takeEvery, call, fork, put } from 'redux-saga/effects';
import { prefillQuotesActions, loadingActions } from 'src/redux/actions';
import { sendCustomerFiscalNumber as sendCustomerFiscalNumberCall } from 'src/redux/api/prefillQuotes';
import TrackingHelper from 'src/utils/trackingHelper';
import { backendApiUrl } from 'src/utils/capabilities';

const START_APPLICATION = 'start_application';

function* sendCustomerFiscalNumber(action) {
  try {
    yield put(loadingActions.showLoader());
    const result = yield call(sendCustomerFiscalNumberCall, {
      clientId: action?.payload?.customerFiscalNumber,
    });
    yield put(loadingActions.hideLoader());

    if (result?.status === 200) {
      TrackingHelper.track('CUIT_ACCOUNT_RETRIEVED', {
        cuitNumber: action?.payload?.customerFiscalNumber,
      });

      if (action?.payload?.shouldRedirect) {
        window.location.replace(result?.data?.redirectionUrl);
      } else {
        TrackingHelper.track(
          'Link Clicked',
          {
            to: START_APPLICATION,
            label: 'Start Application',
            linkName: START_APPLICATION,
          },
          action?.payload?.business,
        );
        window.location = `${backendApiUrl}/admin/impersonates?impersonate_user_id=${action?.business.user.email}&account_uuid=${action?.business.uuid}&cta=${START_APPLICATION}`;
      }
    }
  } catch (e) {
    yield put(loadingActions.hideLoader());

    const failureStatus =
      e?.message === 'Request failed with status code 500'
        ? 'Prefill-Service failed'
        : e.message;
    TrackingHelper.track('CUIT_ACCOUNT_RETRIEVED_FAILED', {
      cuitNumber: action?.payload?.customerFiscalNumber,
      failureReason: failureStatus,
    });
    const error = e.response.data.error;
    yield put(
      prefillQuotesActions.prefillQuotesFailure({
        reason: error?.meta?.key,
        messageKey: error?.meta?.error_message_key,
        isFailed: true,
      }),
    );
  }
}

function* watchPrefillQuotesRequest() {
  yield takeEvery(
    prefillQuotesActions.types.PREFILL_QUOTES_REQUEST,
    sendCustomerFiscalNumber,
  );
}

const prefillQuotesSagas = [fork(watchPrefillQuotesRequest)];

export default prefillQuotesSagas;
